import { render, staticRenderFns } from "./ModalNature.vue?vue&type=template&id=b112fc92"
import script from "./ModalNature.vue?vue&type=script&lang=js"
export * from "./ModalNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports